import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useBienContext } from '../BienContext'

import { PlusIcon } from '@heroicons/react/24/outline'
import DetailTemplate from '@/components/DetailTemplate'
import Form from '../../visites/Form'
import Visite from '../../visites/Visite'
import { fetchVisites, setEmptyCurrentVisite } from '../../visites/visitesSlice'

export default () => {
  const dispatch = useDispatch()
  const { bien, markSectionAsUpdated, updatedSections } = useBienContext()
  const visites = useSelector(state => state.visites.items)
  const isLoading = useSelector( state => state.visites.loadingStatus.fetchList )
 
  const SECTION_ID = 'visites'
  const SECTION_TITLE = 'Visites'

  useEffect(
    () => {
      if(bien?.id) {
        dispatch(fetchVisites({bien_id: bien.id}))
      }
    },
    [ bien.id ]
  )

  const modalContent = <Form />
  
  const AddNewVisiteButton = ({onEditClick}) => {

    const handleClick = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      await dispatch(setEmptyCurrentVisite())
      onEditClick()
    }

    return (
    <div>
      <button 
        className="btn btn-sm btn-primary"
        title="Ajouter une nouvelle visite au bien"
        onClick={handleClick}
      >
        <PlusIcon className="h-5 w-5 mr-1"/> Ajouter une visite
      </button>
    </div>
  )}

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 1}}
      updatedSections={updatedSections}
      loading={isLoading}
      isPendingAction={isLoading}
      editButton={<AddNewVisiteButton />}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
    >
      <div>
        { visites?.length > 0 && (
          <ul>
            {visites?.map((visite, index) => (
              <li key={index}>
                <Visite item={visite} />
              </li>
            ))}
          </ul>
        )}
        { (visites?.length == 0 ) && 
            <p>Aucune visite</p>
        }
      </div>
    </DetailTemplate>
  )
}